import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: any) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
    overflow: "auto",
  },
  pageHeading: {
    fontSize: "1.2rem",
    fontWeight: 500,
    color: "#000",
  },
  display: {
    display: "flex",
    justifyContent: "center",
    height: "100%",
    "& .video-js": {
      width: "100%",
      height: "100%",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
}));
